import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Formik } from 'formik';
import axios from 'axios';
import { successAlert, errorAlert } from '../utils/toastifyAlerts'
import { ToastContainer } from 'react-toastify'
import { useAuth } from "../helpers/auth";

const LoginPage = () => {

  const navigate = useNavigate()

  const { login } = useAuth();

  const handleSubmit = async (values, { resetForm }) => {
    let backendUrl = process.env.REACT_APP_BACKEND_LOGIN_URL
    try {
      await axios.post(backendUrl, {
        email: values.email,
        password: values.password,
      }).then(function (response) {
        localStorage.setItem('token', response.data.token)
        login(response.data.username)
        successAlert(response.data.msg)
        setTimeout(() => {
          navigate('/home')
        }, 2100)
      })
    } catch (error) {
      let msg = error.response.data.msg
      errorAlert(`Login failed: \n ${msg}`)
      resetForm();
    }
  }

  return (
    <div className="App login">
      <div className="title mt-5">
        <h1 data-test="title">
          log in
        </h1>
      </div>
      <Formik
        initialValues={{ email: '', password: '' }}
        validate={values => {
          const errors = {};
          if (!values.email) {
            errors.email = '* Required';
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = 'Invalid email address';
          } else if(!values.password) {
            errors.password = 'This field can not be empty';
          }
          return errors;
        }}
        onSubmit={async (values, resetForm) => {
          await handleSubmit(values, resetForm);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting
        }) => (
          <form className='form-login' onSubmit={handleSubmit}>
            <input
              className='input-form my-2'
              type="email"
              name="email"
              autoComplete="email"
              placeholder="email"
              data-test="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            {errors.email && touched.email && errors.email}
            <input
              className='input-form'
              type="password"
              name="password"
              autoComplete="current-password"
              placeholder="password"
              data-test="password"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
            />
            {errors.password && touched.password && errors.password}
            <button data-test="login" className='btnSCV btnSCV-a btnSCV-long mt-3' type="submit" disabled={isSubmitting}>
              login
            </button>
            <Link data-test='back' className="btnSCV btnSCV-c btnSCV-long" to="/">back</Link>
          </form>
        )}
      </Formik>
      <ToastContainer />
    </div>
  );
}

export default LoginPage;